'use strict';
import { auth, db } from './firebase'

import {
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    signOut,
    sendPasswordResetEmail,
    GithubAuthProvider, signInWithPopup,
    GoogleAuthProvider
} from "firebase/auth";

import {
    query,
    getDocs,
    collection,
    where,
    addDoc,
    updateDoc,
    doc,
} from "firebase/firestore";
import { UserTypes } from '../interfaces/UserTypes';

const logInWithEmailAndPassword = async (email: string, password: string) => {
    return signInWithEmailAndPassword(auth, email, password);
};

const loginGitHub = async () => {
    const provider = new GithubAuthProvider();

    provider.setCustomParameters({
        'allow_signup': 'true'
    });

    var u = null

    await signInWithPopup(auth, provider)
        .then(async (result: any) => {
            const credential = GithubAuthProvider.credentialFromResult(result);
            // const token = credential.accessToken;

            const userData = await getUser(result.user.uid)

            u = result.user

            if (userData == null) {
                await createUser(result.user, result.user.displayName, result.user.email)
            }
        })
        .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            const email = error.customData.email;
            const credential = GithubAuthProvider.credentialFromError(error);
        });

    return u
};

const loginGoogle = async () => {
    const provider = new GoogleAuthProvider();

    var u = null

    await signInWithPopup(auth, provider)
        .then(async (result: any) => {
            // const credential = GoogleAuthProvider.credentialFromResult(result);
            // const token = credential.accessToken;

            const userData = await getUser(result.user.uid)

            u = result.user

            if (userData == null) {
                await createUser(result.user, result.user.displayName, result.user.email)
            }
        })
        .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            const email = error.customData.email;
            const credential = GoogleAuthProvider.credentialFromError(error);
        });

    return u
};

const getUser = async (user_uid: string) => {

    const q = query(
        collection(db, `users`),
        where("uid", "==", user_uid)
    );

    const querySnapshot = await getDocs(q);

    if (querySnapshot.size === 1) {
        return querySnapshot.docs[0].data();
    } else {
        return null
    }
};

const getUserByEmail = async (email: string) => {

    const q = query(
        collection(db, `users`),
        where("email", "==", email)
    );

    const querySnapshot = await getDocs(q);

    if (querySnapshot.size === 1) {
        return querySnapshot.docs[0].data();
    } else {
        return null
    }
};

const registerWithEmailAndPassword = async (name: string, email: string, password: string) => {
    const res = await createUserWithEmailAndPassword(auth, email, password);
    const user: any = res?.user || '';

    await createUser(user, name, email);
};

const createUser = async (user: UserTypes, name: string, email: string) => {
    await addDoc(collection(db, "users"), {
        uid: user.uid,
        name,
        email,
        isValidated: false
    });
};

const sendEmailResetPassword = async (email: string) => {
    console.log(email)

    await sendPasswordResetEmail(auth, email)
        .then(() => {
            console.log('SUCESSO');
        })
        .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            console.log(errorCode, errorMessage);
        });
};

const logout = () => {
    signOut(auth);
};

const updateProfile = async (user_uuid: string, data: any) => {

    const q = query(
        collection(db, `users`),
        where("uid", "==", user_uuid)
    );

    const querySnapshot = await getDocs(q);
    const document = doc(db, "users", querySnapshot.docs[0].id);
    await updateDoc(document, data)
};

export {
    auth,
    db,
    logInWithEmailAndPassword,
    registerWithEmailAndPassword,
    getUser,
    logout,
    updateProfile,
    sendEmailResetPassword,
    loginGitHub,
    loginGoogle,
    getUserByEmail
};
